@if (showFullSettings()) {
    <web-settings-breadcrumbs>
        <div class="breadcrumb-icon">
            <a (click)="onCancel()">
                <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
            </a>
        </div>
        <div class="breadcrumb-text">
            <span>{{ "analytics_form_settings" | translate }}</span>
        </div>
    </web-settings-breadcrumbs>
}
<div [class]="showFullSettings() ? 'panel-options-body overflow-wrapper' : 'form-row'">
    @let siteSettings = websiteSettings$ | async;
    <div class="mb-20">
        <div class="form-group mb-10 form-horizontal row">
            @if (siteSettings?.google_analytics) {
                <div class="col-xs-9">
                    <label>
                        {{ "google_analytic_label" | translate }}
                    </label>
                    <p class="analytic-hint small text-muted mb-0">
                        {{ "how_setting" | translate }}
                        <a [href]="helpGALink" target="_blank">
                            {{ "info_google_link" | translate }}
                            <img
                                class="font-icon-light"
                                src="./assets/img/websites/lpc-new-window-icon.svg"
                                alt="new-window-icon"
                            />
                        </a>
                    </p>
                </div>
                <div class="col-xs-3 control-switch text-right">
                    <sp-switch [active]="googleAnalytic()" (toggleActiveEvent)="toggleGoogleAnalytic($event)" />
                </div>
            } @else {
                <div class="col-xs-12">
                    <label>
                        {{ "google_analytic_label" | translate }}
                    </label>
                    <p class="analytic-hint small text-muted mb-0">
                        {{ "google_analytic_description" | translate }}
                        <a [href]="helpGALink" target="_blank">
                            {{ "how_setting_product" | translate }}
                            <img
                                class="font-icon-light"
                                src="./assets/img/websites/lpc-new-window-icon.svg"
                                alt="new-window-icon"
                            />
                        </a>
                    </p>
                </div>
            }
        </div>

        @if (googleAnalytic()) {
            <div class="well" [class]="showFullSettings() ? '' : 'negative-indents-wrap'">
                <span [innerHtml]="'google_analytic_basic_hint' | translate"></span>
                <span class="help-block small" [innerHtml]="'control_value_currency_hint' | translate"></span>
                <div class="form-group mb-0" [class.has-error]="currencyInvalid()">
                    <label>
                        {{ "currency_label" | translate }}
                    </label>
                    <input
                        class="form-control"
                        placeholder="USD"
                        type="text"
                        [value]="googleSettings().currency ?? ''"
                        (change)="onCurrencyChange($event)"
                    />
                    @if (currencyInvalid()) {
                        <span class="help-block small mb-0">
                            {{ "control_errors_required" | translate }}
                        </span>
                    }
                </div>
                <div
                    class="help-block small text-muted"
                    [innerHtml]="'google_analytic_currency_hint' | translate"
                ></div>
                <div class="form-group mb-0" [class.has-error]="valueInvalid()">
                    <label>
                        {{ "value_label" | translate }}
                    </label>
                    <input
                        class="form-control"
                        min="0"
                        placeholder="9.99"
                        type="number"
                        [value]="googleSettings().value ?? ''"
                        (change)="onValueChange($event)"
                    />
                    @if (valueInvalid()) {
                        <span class="help-block small mb-0">
                            {{ "control_errors_required" | translate }}
                        </span>
                    }
                </div>
                <div class="help-block small text-muted" [innerHtml]="'google_analytic_value_hint' | translate"></div>
                <div class="form-group mb-0">
                    <label>
                        {{ "lead_source_label" | translate }}
                    </label>
                    <input
                        class="form-control"
                        type="text"
                        [value]="googleSettings().leadSource ?? ''"
                        (change)="onLeadSourceChange($event)"
                    />
                </div>
                <div
                    class="help-block small text-muted"
                    [innerHtml]="'google_analytic_lead_source_hint' | translate"
                ></div>
            </div>
        }
    </div>

    <div class="mb-0">
        <div class="form-group mb-10 form-horizontal row">
            @if (siteSettings?.facebook_pixel) {
                <div class="col-xs-9">
                    <label>
                        {{ "facebook_analytic_label" | translate }}
                    </label>
                    <p class="analytic-hint small text-muted mb-0">
                        {{ "how_setting" | translate }}
                        <a [href]="helpPixelLink" target="_blank">
                            {{ "info_facebook_link" | translate }}
                            <img
                                class="font-icon-light"
                                src="./assets/img/websites/lpc-new-window-icon.svg"
                                alt="new-window-icon"
                            />
                        </a>
                    </p>
                </div>
                <div class="col-xs-3 control-switch text-right">
                    <sp-switch [active]="pixelAnalytic()" (toggleActiveEvent)="togglePixelAnalytic($event)" />
                </div>
            } @else {
                <div class="col-xs-12">
                    <label>
                        {{ "facebook_analytic_label" | translate }}
                    </label>
                    <p class="analytic-hint small text-muted mb-0">
                        {{ "facebook_analytic_description" | translate }}
                        <a [href]="helpPixelLink" target="_blank">
                            {{ "how_setting_product" | translate }}
                            <img
                                class="font-icon-light"
                                src="./assets/img/websites/lpc-new-window-icon.svg"
                                alt="new-window-icon"
                            />
                        </a>
                    </p>
                </div>
            }
        </div>
        @if (pixelAnalytic()) {
            <div class="well mb-10">
                <div class="form-group">
                    <label>
                        {{ "pixel_type_label" | translate }}
                    </label>
                    <select class="form-control" (change)="onPixelTypeChange($event)">
                        @for (option of pixelOptions; track option) {
                            <option [value]="option" [selected]="option === pixelType()">
                                {{ option }}
                            </option>
                        }
                    </select>
                    @if (pixelType() === pixelTypes.purchase) {
                        <span class="small text-muted d-block mt-5">
                            {{ "pixel_purchase_analytics" | translate }}
                        </span>
                    }
                </div>
            </div>
        }
    </div>
</div>
